module.exports = __webpack_public_path__ + "img/ai-alerts.6d684a89.png";